module.exports = require('./src/tess2');


//////////////////
// WEBPACK FOOTER
// ./node_modules/tess2/index.js
// module id = 18
// module chunks = 22